export const ATTEMPTS = 3;
